import { FC } from "react";
import {
  Button,
  ButtonSize,
  ButtonVariant,
  IconButton,
  IconButtonVariant,
  Modal
} from "shared/components";

import { Copy06 } from "untitledui-js-base";
import { getErrorMessage } from "utils/error";
import { toast } from "react-toastify";

type Props = {
  opened: boolean;
  onClose: () => void;
  secretKey: string;
};

export const SuccessModal: FC<Props> = ({ opened, onClose, secretKey }) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      panelClassName="items-center lg:min-w-[335px] flex flex-col p-6"
    >
      <p className="mb-2 text-xl font-bold text-content-1000">
        Secret key successfully created
      </p>
      <p className="mb-6 whitespace-pre-line text-center text-base text-content-500">
        This is a unique key and it is non-recoverable. If{"\n"}you lose this
        key you will have to regenerate it.{"\n"}Please save it securely.
      </p>
      <div className="mb-6 flex w-full items-center justify-between rounded-lg border border-alpha-10 bg-alpha-40 p-3">
        <p className="text-base font-medium text-content-1000">{secretKey}</p>
        <IconButton
          onClick={async () => {
            try {
              await navigator.clipboard.writeText(secretKey);
              toast.info("Secret key is copied");
            } catch (err) {
              toast.error(getErrorMessage(err));
            }
          }}
          Icon={Copy06}
          className="!stroke-content-200"
          variant={IconButtonVariant.TEXT}
        />
      </div>
      <div className="w-full">
        <Button
          variant={ButtonVariant.PRIMARY}
          size={ButtonSize.BASE}
          className="w-full"
          onClick={onClose}
        >
          Done
        </Button>
      </div>
    </Modal>
  );
};
